export default "__VITE_ASSET__BV9x5Iqq__"